import MerchantProductsService from '@services/merchant-products-service.js'
import _ from 'lodash'

export const state = {
    selectedMerchantId: sessionStorage.getItem('user.selectedMerchantId'),
    merchants: null,
}

export const getters = {
    selectedMerchantId: (state, getters) =>
        getters.userMerchantId || state.selectedMerchantId,
    isStoresActOnBehalfMerchant: (state, getters) =>
        !getters.isUserMerchantExist && getters.StoresActOnBehalfMerchant,

    isUserMerchantExist: (state, getters) => !!getters.userMerchantId,
    StoresActOnBehalfMerchant: (state, getters, rootState, rootGetters) =>
        rootGetters['auth/StoresActOnBehalfMerchant'],

    merchants: state => state.merchants,
    userMerchantId(state, getters, rootState, rootGetters) {
        return rootGetters['auth/merchantId']
    },
}

export const mutations = {
    UPDATE_MERCHANT_ID(state, { merchantId }) {
        state.selectedMerchantId = merchantId
    },

    UPDATE_MERCHANTS(state, { merchants }) {
        state.merchants = merchants
    },
}

export const actions = {
    updateMerchantId({ commit }, { merchantId }) {
        sessionStorage.setItem('user.selectedMerchantId', merchantId)
        commit('UPDATE_MERCHANT_ID', { merchantId })
    },

    async getMerchants({ commit, getters }) {
        if (getters.userMerchantId) return

        const { merchants } = await MerchantProductsService.getMerchants()
        const merchantId =
            getters.selectedMerchantId || _.get(merchants, '[0]._id')

        sessionStorage.setItem('user.selectedMerchantId', merchantId)
        commit('UPDATE_MERCHANT_ID', { merchantId })
        commit('UPDATE_MERCHANTS', { merchants })
    },
}
